import script from "./HrNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HrNavItem.vue?vue&type=script&setup=true&lang=js"

import "./HrNavItem.vue?vue&type=style&index=0&id=3c2ce707&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2ce707"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
